import { SubscriptionPayload, SubscriptionSignUpOrderSummaryResponse } from "@fitness-force/models";

export const SUBSCRIPTION_PAYLOAD_STATE: SubscriptionPayload = {
    orderSummary: {} as SubscriptionSignUpOrderSummaryResponse,
    err: {}
} as SubscriptionPayload;